import { Select } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../../../../assets/AssetsStore";
import { BlueAdd } from "../../../../../assets/Logos/Icons";
import { followUpSchedule } from "../../../../../reducers/symptom.api";
import DatePickers from "../../../../ManagePrescriptionComponents/DatePicket/DatePicker";
import { PrescriprionContext } from "../../../PrintPrescription";
import DatePickerModal from "../../Modals/DatePickerModal/DatePickerModal";
import InformationModal from "../../Modals/InformationModal/InformationModal";
import styles from "./index.module.scss";
import Textarea from "react-expanding-textarea";

function FollowUp({ haveNote, noteValue }) {
  const dispatch = useDispatch();

  const [isDate, setIsDate] = useState(false);
  const [value, setValue] = useState();
  const [isMessageOPen, setMessageOpen] = useState(false);
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);
  const [showCalendar, setShowCalendar] = useState(false);

  const [textareaHeight, setTextareaHeight] = useState("auto");

  useEffect(() => {
    const textarea = document.getElementById("noteTextarea");
    if (textarea) {
      setTextareaHeight(`${textarea.scrollHeight}px`);
    }
  }, [noteValue]);

  const submissionData = useSelector(
    (state) => state?.managePrescription?.submissionData
  );

  const handleChangeData = ({ key, value, isDate }) => {
    dispatch(
      updateManagePrescriptionSubmissionData({
        [key]: value,
      })
    );
  };

  let handleNoteChange = (e) => {
    let { value } = e?.target;
    handleWholeData("followUpNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        followUp_note: value,
      })
    );
  };

  const createSearchOptions = () => {
    let initialData = [
      "2 Days",
      "5 Days",
      "2 Weeks",
      "3 Weeks",
      "4 Weeks",
      "1 Month",
      "Select custom date",
    ];
    const result = [];
    initialData.map((e) => result.push({ label: e, value: e }));
    return result;
  };

  const handleOnChangeSelect = (e) => {
    console.log("handleOnChangeSelect", e);
    if (e === "Select custom date") {
      setIsDate(true);
      setShowCalendar(true);
      handleWholeData("followUpDate", "");
    } else {
      handleWholeData("followUpDate", e);

      handleChangeData({
        key: "followup_date",
        value: { isDate: false, value: e },
      });
      setValue({ key: "followup_date", value: { isDate: false, value: e } });
    }
  };

  const handleOnChangeDate = (e) => {
    if (dateInPast(e)) {
      handleClearData();
      setShowCalendar(false);
    } else {
      handleWholeData(
        "followUpDate",
        moment(new Date(e)).format("DD-MMM-YYYY")
      );
      handleChangeData({
        key: "followup_date",
        value: { isDate: true, value: e },
      });
      setValue({ key: "followup_date", value: { isDate: true, value: e } });
    }
  };

  useEffect(() => {
    if (wholeData.followUpDate) {
      setValue({
        key: "followup_date",
        value: { isDate: true, value: wholeData.followUpDate },
      });
    }
  }, []);

  const handleSubmit = () => {
    followUpSchedule(
      moment(new Date(value.value.value)).format("DD-MMM-YYYY"),
      () => toggleMessageModal(true)
    );
  };

  const toggleMessageModal = (param) => setMessageOpen(param ? param : false);

  useEffect(() => {
    if (submissionData?.followup_date?.value) {
      setIsDate(submissionData?.followup_date?.isDate);
    }
  }, [submissionData?.followup_date?.isDate]);

  const handleClearData = () => {
    handleWholeData("followUpDate", "");
    setIsDate(false);
    handleChangeData({
      key: "followup_date",
      value: { isDate: false, value: undefined },
    });
    setValue({
      key: "followup_date",
      value: { isDate: false, value: undefined },
    });
  };

  const dateInPast = (date) => {
    const currentDate = new Date();
    if (
      new Date(date)?.setHours(0, 0, 0, 0) < currentDate?.setHours(0, 0, 0, 0)
    ) {
      return true;
    }

    return false;
  };

  const handleKeyDown = (e) => {
    if (e.key === "%") {
      e.preventDefault();
    }
  };

  console.debug("value", submissionData);
  console.debug("date", wholeData?.followUpNote);

  return (
    <div className={styles.followup_container}>
      {/* <div className={styles.caption}>Date</div> */}
      <div className={styles.form_row}>
        <div className={styles.inputAndClearRow}>
          <div className={styles.clear_btn}>
            <div className={styles.title}>Date</div>
            {isDate && (
              <button
                style={{ border: "none", backgroundColor: "white" }}
                onClick={handleClearData}
              >
                Reset
              </button>
            )}
          </div>
          {isDate ? (
            <DatePickers
              value={
                submissionData?.followup_date?.isDate &&
                submissionData?.followup_date?.value &&
                moment(submissionData?.followup_date.value)
              }
              onChange={(e, d) => {
                handleOnChangeDate(e);
              }}
              visible={showCalendar}
            />
          ) : (
            <div className={styles.searchBox}>
              <Select
                // suffixIcon={<img src={AssetStore.managePrescription.calander} alt="" />}
                onSelect={handleOnChangeSelect}
                getPopupContainer={(trigger) => trigger.parentNode}
                placeholder={
                  <span style={{ color: "#757575", marginLeft: "10px" }}>
                    Select a date
                  </span>
                }
                optionFilterProp="children"
                options={createSearchOptions()}
                //defaultValue={"Select a date"}
                // value={
                //   wholeData?.followUpDate !== "" &&
                //   !wholeData?.followUpDate?.isDate &&
                //   wholeData?.followUpDate
                // }
                value={
                  wholeData?.followUpDate !== ""
                    ? !wholeData?.followUpDate?.isDate && wholeData.followUpDate
                    : undefined
                }
              />
            </div>
          )}

          <div className={styles.footer}>
            <div className={styles.caption}>Note</div>
            <div className={styles.textareaContainer}>
              <Textarea
                value={wholeData.followUpNote || ""}
                onChange={handleNoteChange}
                id="noteTextarea"
                className={styles.textarea}
                style={{ height: textareaHeight }}
                maxLength={200}
                onKeyDown={handleKeyDown}
                onPaste={(e) => {
                  e.preventDefault(); // Prevent default paste behavior
                  const pastedData = e.clipboardData.getData("text/plain");
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  const currentValue = e.target.value;

                  // Calculate the available space
                  const availableSpace =
                    200 - (currentValue.length - (end - start));

                  // Truncate the pasted data if necessary
                  const truncatedPastedData = pastedData.substring(
                    0,
                    availableSpace
                  );

                  const newValue =
                    currentValue.substring(0, start) +
                    truncatedPastedData +
                    currentValue.substring(end);

                  // Use the existing handleNoteChange function to update the state
                  handleNoteChange({
                    target: {
                      value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                    },
                  });

                  // Set cursor position after the pasted text
                  setTimeout(() => {
                    e.target.setSelectionRange(
                      start + truncatedPastedData.length,
                      start + truncatedPastedData.length
                    );
                  }, 0);
                }}
              />
              {(wholeData.followUpNote === "" ||
                wholeData.followUpNote === undefined) && (
                <div className={styles.placeholder}>Enter note here</div>
              )}
            </div>
          </div>

          {/* {
                        isDate ? */}
          {/* <DatePickers
            disablePast
            value={
              submissionData?.followup_date?.isDate &&
              submissionData?.followup_date?.value &&
              moment(submissionData?.followup_date.value)
            }
            onChange={(e, d) => {
              handleOnChangeDate(e);
            }}
          /> */}
          {/* : */}
          {/* <div className={styles.searchBox}>
                                <Select
                                    value={!submissionData?.followup_date?.isDate && submissionData?.followup_date?.value}
                                    // suffixIcon={<img src={AssetStore.managePrescription.calander} alt="" />}
                                    onChange={handleOnChangeSelect}
                                    getPopupContainer={trigger => trigger.parentNode}
                                    placeholder="Select a date"
                                    optionFilterProp="children"
                                    options={createSearchOptions()}
                                />
                            </div> */}
          {/* } */}
        </div>

        {/* <button
          disabled={submissionData?.followup_date?.value ? false : true}
          onClick={handleSubmit}
          className={styles.schedule_btn}
        >
          Schedule
        </button> */}
      </div>

      <InformationModal
        onSubmit={(e) => {
          toggleMessageModal(false);
        }}
        title={"Successfully scheduled."}
        showModal={isMessageOPen}
        hidemodal={() => {
          toggleMessageModal(false);
        }}
      />
    </div>
  );
}

export default FollowUp;